import { Link, LinkProps } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

const LocalizedLink = ({ to, children, ...props }: LocalizedLinkProps) => {
  const { getLocalizedPath } = useLanguage();
  
  // Don't localize external links or anchor links
  if (to.startsWith('http') || to.startsWith('#') || to.startsWith('mailto:')) {
    return <Link to={to} {...props}>{children}</Link>;
  }
  
  return (
    <Link to={getLocalizedPath(to)} {...props}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
